<template>
  <div class="container-warp">
    <van-nav-bar title="错题本"
                 left-arrow
                 @click-left="pageBack"
                 @click-right="openSearch"
                 fixed
                 z-index="99">
      <template #right>
        <van-icon name="search"
                  size="20" />
      </template>
    </van-nav-bar>
    <van-list v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
      <van-cell-group inset
                      v-for="item in list"
                      :key="item.id"
                      class="list-item">
        <div class="list-item-hd">
          <span>{{item.questionTypeDesc}}</span>
          <span class="text-gray">{{item.errorTime}}</span>
        </div>
        <div class="list-item-bd">
          <p class="van-multi-ellipsis--l2">试题题目：{{item.titleName}}</p>
          <p class="text-danger">错误次数：{{item.count}}</p>
          <p class="text-gray">所属题库：{{ item.bankName }}</p>
        </div>
        <div class="list-item-foot">
          <van-button type="info"
                      size="small"
                      @click="onDetail(item)"
                      icon="description-o">详情</van-button>
        </div>
      </van-cell-group>
    </van-list>
    <!-- 搜索过滤 -->
    <Search-filter ref="SearchFilter"
                   @handle-filter="submitFilter"></Search-filter>
  </div>
</template>

<script>
import { mistakeQuestionList } from "@/api/examQuestionBank.js";
import SearchFilter from "@/view/examQuestionBank/components/search-filter.vue";
export default {
  name: 'MistakeNotebook',
  components: {
    SearchFilter
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 20,
      searchParams: {
        bankName: "",
        questionTag: "",
        questionType: "",
        titleName: ""
      }
    }
  },
  methods: {
    async onLoad() {
      const params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        ...this.searchParams
      }
      // console.log(params)
      const { status, data } = await mistakeQuestionList(params);
      if (status == 200) {
        let records = data.list || [];
        this.list.push(...records)
        this.total = data.total;
        this.pageNum++;
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        // 加载状态结束
        this.loading = false;
      }
    },

    // 查看详情
    onDetail(row) {
      this.$router.push({ path: '/questionDetails', query: { id: row.questionId } })
    },
    resetList() {
      this.pageNum = 1;
      this.list = []
      this.finished = false;
      this.loading = false;
    },
    openSearch() {
      this.$refs.SearchFilter.open()
    },
    async submitFilter(params) {
      this.pageNum = 1;
      this.searchParams = { ...params }
      const queryParams = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        ...this.searchParams,
        titleName: this.searchParams.content
      }
      // console.log(queryParams)
      const { status, data } = await mistakeQuestionList(queryParams);
      if (status == 200) {
        this.list = [...data.list]
        this.total = data.total;
        this.pageNum++;
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        // 加载状态结束
        this.loading = false;
      }
    },
    pageBack() {
      this.$router.replace('/index')
    },
  },
}
</script>

<style lang="less" scoped>
@import url("~@/assets/css/list-style.less");
.list-item {
  .list-item-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
  }
}
</style>
